/**
 * Header Mega Menu - Ghia-style navigation
 * Mega + simple menu-list dropdowns on desktop (hover + focus)
 * Mobile: hamburger toggle + accordion for nav items with children
 */

document.querySelectorAll('.header-mega-menu').forEach((menu) => {
  const mobileToggle = menu.querySelector('[data-mobile-toggle]');
  const mobileDrawer = menu.querySelector('.header-mega-menu__mobile-drawer');

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileDrawer.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      mobileDrawer.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    document.addEventListener('click', (e) => {
      if (mobileDrawer.classList.contains('is-open') && !menu.contains(e.target)) {
        mobileDrawer.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  menu.querySelectorAll('.header-mega-menu__mobile-item.has-children').forEach((item) => {
    const expandBtn = item.querySelector('.header-mega-menu__mobile-expand');
    const sub = item.querySelector('.header-mega-menu__mobile-sub');
    if (!expandBtn || !sub) return;

    expandBtn.addEventListener('click', (e) => {
      e.preventDefault();
      menu.querySelectorAll('.header-mega-menu__mobile-item.has-children').forEach((other) => {
        if (other !== item) {
          other.classList.remove('is-open');
          const otherExpandBtn = other.querySelector('.header-mega-menu__mobile-expand');
          const otherSub = other.querySelector('.header-mega-menu__mobile-sub');
          if (otherExpandBtn) otherExpandBtn.setAttribute('aria-expanded', 'false');
          if (otherSub) otherSub.hidden = true;
        }
      });
      const isOpen = item.classList.toggle('is-open');
      expandBtn.setAttribute('aria-expanded', isOpen);
      sub.hidden = !isOpen;
    });
  });

  const megaDropdown = menu.querySelector('[id^="mega-menu-"]');
  const megaTriggers = menu.querySelectorAll('[data-mega-trigger]');
  const megaContents = megaDropdown ? megaDropdown.querySelectorAll('[data-mega-content]') : [];
  const megaInner = megaDropdown?.querySelector('.header-mega-menu__dropdown-inner');

  const simpleDropdown = menu.querySelector('[id^="simple-menu-"]');
  const simpleTriggers = menu.querySelectorAll('[data-simple-menu-trigger]');
  const simplePanels = simpleDropdown ? simpleDropdown.querySelectorAll('[data-simple-menu-panel]') : [];
  const simpleInner = simpleDropdown?.querySelector('.header-mega-menu__dropdown-inner');

  const hasMega = Boolean(megaDropdown && megaTriggers.length && megaInner);
  const hasSimple = Boolean(simpleDropdown && simpleTriggers.length && simpleInner);

  if (!hasMega && !hasSimple) return;

  const HIDE_DELAY = 350;
  let hideTimeout;

  function isDesktopNav() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function closeMegaImmediate() {
    if (!megaDropdown) return;
    megaDropdown.classList.remove('is-open');
    megaDropdown.setAttribute('aria-hidden', 'true');
    megaDropdown.style.background = '';
    megaDropdown.style.removeProperty('height');
    megaContents.forEach((c) => {
      c.hidden = true;
    });
    megaTriggers.forEach((trigger) => {
      const navItem = trigger.closest('.header-mega-menu__nav-item');
      if (navItem) navItem.classList.remove('is-open');
    });
  }

  function closeSimpleImmediate() {
    if (!simpleDropdown) return;
    simpleDropdown.classList.remove('is-open');
    simpleDropdown.setAttribute('aria-hidden', 'true');
    simpleDropdown.style.removeProperty('height');
    simplePanels.forEach((p) => {
      p.hidden = true;
    });
    simpleTriggers.forEach((trigger) => {
      const navItem = trigger.closest('.header-mega-menu__nav-item');
      if (navItem) navItem.classList.remove('is-open');
    });
  }

  function hideDropdownDelayed() {
    hideTimeout = setTimeout(() => {
      closeMegaImmediate();
      closeSimpleImmediate();
    }, HIDE_DELAY);
  }

  function applyDropdownHeight(dropdownEl) {
    if (!dropdownEl || !dropdownEl.classList.contains('is-open') || !isDesktopNav()) {
      dropdownEl?.style.removeProperty('height');
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!dropdownEl.classList.contains('is-open') || !isDesktopNav()) return;

        dropdownEl.style.height = 'auto';
        void dropdownEl.offsetHeight;

        const next = Math.ceil(dropdownEl.scrollHeight);
        if (next > 0) {
          dropdownEl.style.height = `${next}px`;
        }
      });
    });
  }

  function applyMegaDropdownHeight() {
    if (megaDropdown) applyDropdownHeight(megaDropdown);
  }

  function applySimpleDropdownHeight() {
    if (simpleDropdown) applyDropdownHeight(simpleDropdown);
  }

  let resizeThrottle = false;
  window.addEventListener(
    'resize',
    () => {
      if (resizeThrottle) return;
      resizeThrottle = true;
      requestAnimationFrame(() => {
        resizeThrottle = false;
        applyMegaDropdownHeight();
        applySimpleDropdownHeight();
      });
    },
    { passive: true }
  );

  if (hasMega && megaInner) {
    new ResizeObserver(() => applyMegaDropdownHeight()).observe(megaInner);
  }
  if (hasSimple && simpleInner) {
    new ResizeObserver(() => applySimpleDropdownHeight()).observe(simpleInner);
  }

  if (document.fonts?.ready) {
    document.fonts
      .ready.then(() => {
        applyMegaDropdownHeight();
        applySimpleDropdownHeight();
      })
      .catch(() => {});
  }

  function cancelHide() {
    clearTimeout(hideTimeout);
  }

  if (hasMega) {
    function showMegaDropdown(blockId) {
      cancelHide();
      closeSimpleImmediate();

      megaDropdown.classList.add('is-open');
      megaDropdown.setAttribute('aria-hidden', 'false');

      megaTriggers.forEach((trigger) => {
        const navItem = trigger.closest('.header-mega-menu__nav-item');
        if (navItem && trigger.getAttribute('data-mega-block') === String(blockId)) {
          navItem.classList.add('is-open');
        } else if (navItem) {
          navItem.classList.remove('is-open');
        }
      });

      megaContents.forEach((content) => {
        const isActive = content.getAttribute('data-mega-content') === String(blockId);
        content.hidden = !isActive;
        if (isActive) {
          const bg = content.getAttribute('data-background');
          megaDropdown.style.background = bg || '';
        }
      });

      applyMegaDropdownHeight();
    }

    megaTriggers.forEach((trigger) => {
      const blockId = trigger.getAttribute('data-mega-block');
      if (!blockId) return;

      trigger.addEventListener('mouseenter', () => showMegaDropdown(blockId));
      trigger.addEventListener('focus', () => showMegaDropdown(blockId));
    });

    megaDropdown.addEventListener('mouseenter', cancelHide);
    megaDropdown.addEventListener('mouseleave', hideDropdownDelayed);

    megaTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseleave', (e) => {
        const goingToDropdown = megaDropdown.contains(e.relatedTarget);
        if (!goingToDropdown && !trigger.contains(e.relatedTarget)) {
          hideDropdownDelayed();
        }
      });
      trigger.addEventListener('focusout', (e) => {
        if (!megaDropdown.contains(e.relatedTarget) && !trigger.contains(e.relatedTarget)) {
          hideDropdownDelayed();
        }
      });
    });
  }

  if (hasSimple) {
    function showSimpleDropdown(blockId) {
      cancelHide();
      closeMegaImmediate();

      simpleDropdown.classList.add('is-open');
      simpleDropdown.setAttribute('aria-hidden', 'false');

      simpleTriggers.forEach((trigger) => {
        const navItem = trigger.closest('.header-mega-menu__nav-item');
        if (navItem && trigger.getAttribute('data-simple-menu-block') === String(blockId)) {
          navItem.classList.add('is-open');
        } else if (navItem) {
          navItem.classList.remove('is-open');
        }
      });

      simplePanels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-simple-menu-panel') !== String(blockId);
      });

      applySimpleDropdownHeight();
    }

    simpleTriggers.forEach((trigger) => {
      const blockId = trigger.getAttribute('data-simple-menu-block');
      if (!blockId) return;

      trigger.addEventListener('mouseenter', () => showSimpleDropdown(blockId));
      trigger.addEventListener('focus', () => showSimpleDropdown(blockId));
    });

    simpleDropdown.addEventListener('mouseenter', cancelHide);
    simpleDropdown.addEventListener('mouseleave', hideDropdownDelayed);

    simpleTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseleave', (e) => {
        const goingToDropdown = simpleDropdown.contains(e.relatedTarget);
        if (!goingToDropdown && !trigger.contains(e.relatedTarget)) {
          hideDropdownDelayed();
        }
      });
      trigger.addEventListener('focusout', (e) => {
        if (!simpleDropdown.contains(e.relatedTarget) && !trigger.contains(e.relatedTarget)) {
          hideDropdownDelayed();
        }
      });
    });
  }
});
